import React, { Component } from 'react'
import DialogWrapper from '../../../../components/DialogWrapper'
import { Button, IconButton, Typography } from '@mui/material';
import { ALERT_SEVERITY } from '../../../../components/AlertDisplay2';
import ShopSelectionSection, { SHOP_SELECTION_TYPES } from './Sections/ShopSelectionSection';
import { getShopInfoByIdList } from '../../../../APIHelper';
import EntitySelectionDialog from '../../../../components/EntitySelection/EntitySelectionDialog';
import { APIData } from '../../../../constants/APIAdresses';
import ApiSingleAutocomplete from '../../../../components/APISingleAutoComplete';
import { Box } from '@mui/system';
import CustomLightButton from '../../../../components/CustomLightButton';
import { Delete, Edit } from '@mui/icons-material';
import GenericTable from '../../../../components/GenericTable/GenericTable';
import { formatDateBerlin } from '../../../../App';

const formatMoney = (n) => `${Number(n).toFixed(2).replace('.', ',')} €`
const formatPercent = (n) => `${Number(n).toFixed(2).replace('.', ',')} %`
const columns = [
    {
        label: 'ID',
        dataKey: 'id',
        width: 80,
    },
    {
        label: 'Promo-ID',
        dataKey: 'promoId',
        width: 100,
    },
    {
        label: 'Code',
        dataKey: 'code',
        width: 140,
    },
    {
        label: 'Bestell-ID',
        dataKey: 'orderId',
        width: 110,
    },
    {
        label: "Prozentualer Rabatt",
        dataKey: 'percent',
        width: 160,
        format: (value) => value != null ? formatPercent(value) : '-',
    },
    {
        label: 'Fester Rabatt',
        dataKey: 'fixed',
        width: 140,
        format: (value) => value != null ? formatMoney(value) : '-',
    },
    // {
    //     label: 'Rabatthöhe',
    //     dataKey: 'discountValue',
    //     width: 130,
    //     format: (_, row) => {
    //         return row.percent != null
    //             ? formatPercent(row.percent)
    //             : formatMoney(row.fixed);
    //     }
    // },
    {
        label: 'Gewährter Rabatt',
        dataKey: 'discountGross',
        width: 140,
        format: (value) => formatMoney(value),
    },
    {
        label: 'Maximaler Rabatt',
        dataKey: 'maxDiscount',
        width: 140,
        format: (value) => value != null ? formatMoney(value) : '-',
    },
    {
        label: 'Mindestbestellwert',
        dataKey: 'minOrderAmount',
        width: 160,
        format: (value) => value != null ? formatMoney(value) : '-',
    },
    {
        label: 'Datum',
        dataKey: 'createdAt',
        width: 160,
        format: (value) => value ? formatDateBerlin(value) : '-',
    },
];

export default class PromoLedgerDialog extends Component {
    state = {
        allShopInfoList: [],
        selectedShopIds: this.props.shopId ? [{ id: this.props.shopId }] : [],
        preSelectedEntities: this.props.shopId ? [{ id: this.props.shopId }] : [],
        // selectedPromoCode: this.props.preSelectedPromoCode ?? null,
        selectedPromoCode: null,
        entitySelectionDialogOpen: false,
        entitySelectionDialogMultipleSelection: true,
        entitySelectionDialogTitle: "",
        entitySelectionDialogApiEndpoint: "",
        entitySelectionDialogIcon: null,
        entitySelectionDialogChipRenderContent: null,
        onEntitySelectionFinished: null,
        entitySelectionDialogMethod: "GET",
        entitySelectionDialogAdditionalKeyFields: [],
        entitySelectionDialogBody: undefined,
        tableData: [],
    }
    async componentDidMount() {
        const result = await getShopInfoByIdList(null, this.props.companyId);
        this.setState({ allShopInfoList: result });
    }
    filterEntitySelectionResults(result) {
        const { editMode } = this.state;
        if (!editMode) {
            return result.map(item => {
                const { added, ...rest } = item;
                return rest;
            }).filter(item => item.deselected !== true); // also remove deselected ones in creation mode, since they are not relevant at all
        }
        return result;
    }
    render() {
        const { shopId, companyId, open, onClose, showAlert } = this.props;
        return (
            <DialogWrapper maxWidth='xl' title="Historie" open={open} onClose={() => onClose()} >
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {/* <Typography>Ledger Dialog - Shop: {shopId}, Company: {companyId} - SELECTED SHOPIDS: {JSON.stringify(this.state.selectedShopIds)} - ALLSHOPINFO: {JSON.stringify(this.state.allShopInfoList)}</Typography> */}
                    {this.state.allShopInfoList.length > 0 && (
                        <ShopSelectionSection shopList={this.state.allShopInfoList} selectedShops={this.state.selectedShopIds} selectedCompanyId={this.state.selectedCompanyId}
                            selectionType={this.state.shopSelectionType}
                            setSelectionType={(type) => {
                                console.log("Selected shop selection type: ", type);
                                if (type === SHOP_SELECTION_TYPES.NO_RESTRICTIONS) {
                                    console.log("Setting state to: ", { selectedCompanyId: companyId, shopSelectionType: type });
                                    this.setState({ selectedCompanyId: companyId, shopSelectionType: type })
                                } else {
                                    console.log("Setting state to: ", { selectedCompanyId: null, shopSelectionType: type });
                                    this.setState({ selectedCompanyId: null, shopSelectionType: type })
                                }
                            }}
                            onShopSelectionChange={(selectedShops) => {
                                console.log("Selected shops: ", selectedShops);
                                if (selectedShops.length === 0) {

                                    showAlert("Es muss mindestens ein Shop ausgewählt werden.", ALERT_SEVERITY.WARNING);
                                    return;
                                }
                                this.setState({ selectedShopIds: selectedShops, preSelectedEntities: selectedShops })
                            }}
                            onShopSelectionPressed={() => {
                                this.setState({
                                    entitySelectionDialogOpen: true,
                                    entitySelectionDialogMultipleSelection: true,
                                    entitySelectionDialogBody: undefined,
                                    entitySelectionDialogMethod: "GET",
                                    entitySelectionDialogTitle: "Shopauswahl",
                                    entitySelectionDialogApiEndpoint: (page, ipp, search) => `${APIData.SHOP}/getShopsPaginated?page=${page}&ipp=${ipp}${companyId != null ? `&companyId=${companyId}` : ""}${search != null && search.length > 3 ? `&search=${encodeURIComponent(search)}` : ""}`,
                                    entitySelectionDialogIcon: require("../../../../assets/icons/store.png"),
                                    entitySelectionDialogChipRenderContent: (item) => {
                                        return <div style={{ display: "flex", flexDirection: "column", flex: 1, gap: 5 }}>
                                            <span
                                                style={{
                                                    fontSize: 16,
                                                    color: "#353535",
                                                }}
                                            >
                                                <strong>Shop:</strong> {item.name}{"  "}
                                                <strong>(ID.:</strong> {item.id})
                                            </span>

                                            <span
                                                style={{
                                                    fontSize: 16,
                                                    color: "#676767",
                                                }}
                                            >
                                                Adresse: {item.street} {item.houseNumber}, {item.zip} {item.city}
                                            </span>
                                        </div>
                                    },
                                    onEntitySelectionFinished: (finalItems) => {
                                        this.setState({ selectedShopIds: finalItems, preSelectedEntities: finalItems });
                                    }
                                    // onEntitySelectionFinished: (result) => {
                                })
                            }} editMode={this.state.editMode} showAlert={showAlert} withoutTypeSelection />
                    )}
                    {/* <div style={{ display: "flex" }}> */}
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        <Box
                            onClick={this.onPress}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                border: "0.5px solid #D3D3D3",
                                borderRadius: "10px",
                                padding: "10px 12px",
                                cursor: !this.state.selectedPromoCode ? "not-allowed" : "pointer",
                                userSelect: "none",
                                backgroundColor: "#fff",
                                opacity: !this.state.selectedPromoCode ? 0.7 : 1,
                                width: "100%",
                                minWidth: 0,
                                height: 55,
                                boxSizing: "border-box",
                                overflow: "hidden",
                                // ...style
                            }}
                        >
                            <div style={{ flex: 1 }}>
                                {!this.state.selectedPromoCode ? "Keine Aktionscode ausgewählt" : `Aktionscode: ${this.state.selectedPromoCode.code} (ID: ${this.state.selectedPromoCode.id})`}
                            </div>
                            {this.state.selectedPromoCode && (
                                <IconButton>
                                    <Edit fontSize='small' />
                                </IconButton>
                            )}

                        </Box>
                        {!this.state.selectedPromoCode ?
                            <CustomLightButton
                                icon={require('../../../../assets/icons/voucher.png')} label="Aktionscode-Filter Hinzufügen"
                                onPress={() => {
                                    this.setState({
                                        entitySelectionDialogOpen: true,
                                        entitySelectionDialogMultipleSelection: false,
                                        entitySelectionDialogTitle: "Aktionscode Auswahl",
                                        // for the standalone version we have to load all promo codes!
                                        // However we have there either shop or promo code filter!? Let think about it later :D
                                        entitySelectionDialogApiEndpoint: (page, ipp, search) => `${APIData.SHOP}/multiShopPromocodes?page=${page}&ipp=${ipp}${search != null && search.length > 3 ? `&search=${encodeURIComponent(search)}` : ""}`,
                                        entitySelectionDialogMethod: "POST",
                                        entitySelectionDialogAdditionalKeyFields: ["code", "publicDescription"],
                                        entitySelectionDialogBody: {
                                            shopIds: this.state.selectedShopIds.map(s => s.id)
                                        },
                                        entitySelectionDialogIcon: require("../../../../assets/icons/voucher.png"),
                                        entitySelectionDialogChipRenderContent: (item) => {
                                            return <div style={{ display: "flex", flexDirection: "column", flex: 1, gap: 5 }}>
                                                <span
                                                    style={{
                                                        fontSize: 16,
                                                        color: "#353535",
                                                    }}
                                                >
                                                    <strong>Code:</strong> {item.code}{"  "}
                                                    <strong>(ID.:</strong> {item.id})
                                                </span>

                                                <span
                                                    style={{
                                                        fontSize: 16,
                                                        color: "#676767",
                                                    }}
                                                >
                                                    {item.publicDescription}
                                                </span>
                                            </div>
                                        },
                                        onEntitySelectionFinished: (finalItems) => {
                                            this.setState({ selectedPromoCode: finalItems?.[0] ?? null });
                                        }
                                    })
                                }} />
                            :
                            <Button sx={{ minHeight: 44 }} color='error' onClick={() => { this.setState({ selectedPromoCode: null }) }} variant='contained' startIcon={<Delete />}><strong>Filter Löschen</strong></Button>
                        }
                    </div>
                    <GenericTable
                        config={{ columns: [...columns] }}
                        apiEndPoint={`${APIData.USER}/promocode/redemptions?${this.state.selectedShopIds.map(shop => `shopIdList=${shop.id}`).join("&")}${this.state.selectedPromoCode ? `&promoCodeId=${this.state.selectedPromoCode.id}` : ""}`}
                        tableData={this.state.tableData}
                        defaultItemsPerPage={25}
                        setTableData={(data) => this.setState({ tableData: data })}
                        onClickRow={(index) => {
                            // this.setState({
                            //     // dialogOpen: true,
                            //     conflictData: this.props.tableData[index],
                            // });
                        }}
                        noAdd
                    />
                    {/* <GenericTable /> */}
                    {/* </div> */}
                    {/* <Button onClick={() => showAlert('Test Alert', ALERT_SEVERITY.WARNING)}>Test Alert</Button> */}
                </div>
                {this.state.entitySelectionDialogOpen && this.state.entitySelectionDialogApiEndpoint && (
                    <EntitySelectionDialog
                        showAlert={showAlert}
                        isOpen={this.state.entitySelectionDialogOpen}
                        title={this.state.entitySelectionDialogTitle}
                        apiEndpoint={this.state.entitySelectionDialogApiEndpoint}
                        keyFieldName="id"
                        icon={this.state.entitySelectionDialogIcon}
                        // apiEndpoint={(page, ipp, search) => `${APIData.SHOP}/getShopsPaginated?page=${page}&ipp=${ipp}${companyId != null ? `&companyId=${companyId}` : ""}${search != null && search.length > 3 ? `&search=${encodeURIComponent(search)}` : ""}`}
                        method={this.state.entitySelectionDialogMethod ?? "GET"}
                        multipleSelection={this.state.entitySelectionDialogMultipleSelection}
                        deselectionDisabled={this.state.editMode}
                        data={this.state.preSelectedEntities}
                        searchPlaceholder={"Suche"}
                        additionalKeysToAdd={this.state.entitySelectionDialogAdditionalKeyFields}
                        // additionalKeysToAdd={[]}
                        body={this.state.entitySelectionDialogBody ?? undefined}
                        onClose={() => this.setState({ entitySelectionDialogOpen: false, entitySelectionDialogApiEndpoint: null })}
                        onFinish={(result) => {
                            this.setState({ entitySelectionDialogOpen: false });
                            if (result) {
                                // user pressed submit
                                console.log("Selected:", result);
                                const finalItems = this.filterEntitySelectionResults(result);
                                if (finalItems?.length > 0) {
                                    // to do we have to check which are not at the allShopInfo and
                                    // have to load all shop info for those to be able to show the chips correctly
                                    // this is crucial for the standalone version. For the company based version we already have all shop info loaded, so we can directly set the state
                                    this.state.onEntitySelectionFinished(finalItems);
                                    console.log("Selected shops: ", finalItems);
                                } else {
                                    showAlert("Es muss mindestens ein Shop ausgewählt werden.", ALERT_SEVERITY.WARNING);
                                }
                            }
                        }}
                        renderChipContent={(item) => (
                            this.state.entitySelectionDialogChipRenderContent(item)
                        )}
                    />
                )}
            </DialogWrapper>
        )
    }
}
